<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import defaultLang from 'element-ui/lib/locale/lang/zh-CN';
  export default {

    name: 'App',
    created() {
      //修改element-ui中级联控制器的文本提示
      this.$nextTick(args => {
        defaultLang.el.cascader.placeholder = "试试搜索：北京，或者选择"
      })
      // this.$store.dispatch("queryCodeDict")
    }
  }
</script>

<style>
  html,body{
    padding: 0;
    margin: 0;
    height: 100%;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }
  #app {
    background-color: rgb(238,245,252);
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
    margin-top: 0px;
    height: 100%;
  }
  *{
    box-sizing: border-box;
  }
  button {
    cursor: pointer;
  }

  a, a:hover, a:active, a:visited {
    color: inherit;
    text-decoration: none;
  }
  /*.el-scrollbar__wrap{*/
  /*  overflow-x: hidden;*/
  /*}*/


</style>



// WEBPACK FOOTER //
// src/App.vue